import { makeStyles } from "@mui/styles"

export default makeStyles(() => ({
    title: {
        fontSize: 14,
        fontWeight: 'bold',
    },

    expansibleContent: {
        padding: 10,
        backgroundColor: '#EFEFEF',
    },

    processHeadInfo: {
        display: 'flex',
        flexDirection: 'column',
        margin: 10,
    },

    alertDiv: {
      margin: '20px 0',
    },
}))
